export const allowedEnvs = {
  dev: { uri: process.env.REACT_APP_GRAPHQL_URI_DEV, type: "graphql" },
  qa: { uri: process.env.REACT_APP_GRAPHQL_URI_QA, type: "graphql" },
  uat: { uri: process.env.REACT_APP_GRAPHQL_URI_US_UAT, type: "graphql" },
  prod: { uri: process.env.REACT_APP_GRAPHQL_URI_US_PROD, type: "graphql" },
  apUat: { uri: process.env.REACT_APP_GRAPHQL_URI_SIN_UAT, type: "graphql" },
  apProd: { uri: process.env.REACT_APP_GRAPHQL_URI_SIN_PROD, type: "graphql" }
};

// The per-environment AppSync `default` key, sent as `x-evn-api-key` and validated
// by the backend's Lambda authorizer against SSM /evn/<stage>/browser-api-key/.
export const envKeys = {
  dev: process.env.REACT_APP_API_KEY_DEV,
  qa: process.env.REACT_APP_API_KEY_QA,
  uat: process.env.REACT_APP_API_KEY_US_UAT,
  prod: process.env.REACT_APP_API_KEY_US_PROD,
  apUat: process.env.REACT_APP_API_KEY_SIN_UAT,
  apProd: process.env.REACT_APP_API_KEY_SIN_PROD
};

// Auth0. Domains, audiences, the realm and the email claim are not secrets, so they
// are literals here; only the client ids come from the environment.
export const AUTH0_REALM = "Username-Password-Authentication";
export const AUTH0_SCOPE = "openid profile email";
export const AUTH0_EMAIL_CLAIM = "https://envana.com/email";

export const auth0Tenants = {
  devQa: {
    domain: "dev-qa-login.envana.com",
    audience: "auth0.api.catalyst.dev-qa",
    clientId: process.env.REACT_APP_AUTH0_CLIENT_ID_DEV_QA
  },
  prodUat: {
    domain: "login.envana.com",
    audience: "auth0.api.catalyst.us-prod-uat",
    clientId: process.env.REACT_APP_AUTH0_CLIENT_ID_PROD_UAT
  }
};

// The six app environments map onto two Auth0 tenants. A token is only valid against
// the tenant that minted it — different signing keys, issuer and audience — so every
// token check keys on this, never on the environment name.
export const envAuth0Tenant = {
  dev: "devQa",
  qa: "devQa",
  uat: "prodUat",
  prod: "prodUat",
  apUat: "prodUat",
  apProd: "prodUat"
};

export const auth0TenantForEnv = (env) => envAuth0Tenant[env] ?? null;

export const auth0ConfigForEnv = (env) => auth0Tenants[envAuth0Tenant[env]] ?? null;

// The two accounts this tool allows. The typed username omits the `.app` part of the
// address; the full email is accepted verbatim too.
export const adminAccounts = [
  { username: "admin", email: "admin.app@envana.com", role: "admin" },
  { username: "admin-viewer", email: "admin-viewer.app@envana.com", role: "viewer" }
];

const normalize = (value) =>
  String(value ?? "")
    .trim()
    .toLowerCase();

// Accepts either the short username or the full email; null for anything else.
export const accountForLogin = (input) => {
  const value = normalize(input);
  if (!value) {
    return null;
  }
  return adminAccounts.find((account) => account.username === value || account.email === value) ?? null;
};

export const accountForEmail = (email) => {
  const value = normalize(email);
  return adminAccounts.find((account) => account.email === value) ?? null;
};

export const resolveLoginEmail = (input) => accountForLogin(input)?.email ?? null;

export const roleForEmail = (email) => accountForEmail(email)?.role ?? null;

export const usernameForEmail = (email) => accountForEmail(email)?.username ?? null;

export const DEFAULT_TENANT_ID = "9e91edd4-b9c8-466c-85b4-5098523b8936";
